import { Upload } from "lucide-react";

/** Étape 1 : zone d'upload de la photo de façade (drag & drop + clic). */
export function UploadArea({ onDrop, onOpenPicker }) {
  return (
    <div
      data-testid="configurator-upload-area"
      className="relative aspect-[16/10] rounded-3xl overflow-hidden border-2 border-dashed border-white/15 bg-[#0a0a0a] hover:border-[#FF5A00]/50 transition-colors"
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
    >
      <button
        type="button"
        onClick={onOpenPicker}
        data-testid="configurator-upload-btn"
        className="absolute inset-0 flex flex-col items-center justify-center gap-5 text-neutral-400 hover:text-white transition-colors"
      >
        <div className="w-24 h-24 rounded-full border-2 border-white/20 flex items-center justify-center bg-white/[0.02]">
          <Upload size={32} className="text-[#FF5A00]" />
        </div>
        <div className="text-center px-6 max-w-md">
          <div className="text-xl md:text-2xl text-white font-display mb-2">
            Uploadez une photo de votre façade
          </div>
          <div className="text-sm">
            Glissez votre image ici ou cliquez pour la sélectionner
            <br />
            <span className="text-neutral-500">JPG, PNG · max 20 Mo (compressé auto.)</span>
          </div>
        </div>
      </button>
    </div>
  );
}
